module.exports = __webpack_public_path__ + "static/media/map8.ef5e61eb.gif";